import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { getDifferentPrefixToPath } from '../../ManagementPanel/utils';

import Users from '../Users';
import Teams from '../Teams';

const ManageUsers = () => {
  return (
    <div>
      <Switch>
        <Route path={getDifferentPrefixToPath(['/users', '/manage-users/users'])} component={Users} />
        <Route path={getDifferentPrefixToPath(['/teams', '/manage-users/teams'])} component={Teams} />
        <Redirect path={getDifferentPrefixToPath('/manage-users')} to="users/" />
      </Switch>
    </div>
  );
};

export default ManageUsers;
